<div [ngClass]="(!showCloseBtn) ? ['my-8', 'my-lg-13'] : []"
  class="mx-xl-0 p-5 px-4 px-xl-7 py-xl-8 evisa-bg-white rounded-5 visa-instructions-container">
  @if (showCloseBtn) {
  <div class="d-flex justify-content-end">
    <img class="m-3 c-pointer" src="assets/icons/close-blue.svg" (click)="activeModal.dismiss('Cross click')">
  </div>
  }
  <div class="col-12">
    <p class="heading-2 ibm-semibold pb-5 linear-gradient-text">
      {{ "VISA_INSTRUCTIONS.TITLE" | translate }}
    </p>
    <div class="d-flex align-items-center flex-column entry-types-container">
      <div class="d-flex justify-content-center gap-3 flex-wrap">
        <button class="tab-button py-2" [ngClass]="currentEntryType === 'single' ? 'btn-1' : 'btn-secondary'"
          type="button" (click)="getVisaEntryTypeDetails('single')">
          {{'CREATE_VISA.ACCOMODATION_INFO.SINGLE_ENTRY' | translate}}
        </button>
        <button class="tab-button py-2" [ngClass]="currentEntryType === 'multiple' ? 'btn-1' : 'btn-secondary'"
          type="button" (click)="getVisaEntryTypeDetails('multiple')">
          {{'CREATE_VISA.ACCOMODATION_INFO.MULTIPLE_ENTRY' | translate}}
        </button>
      </div>
      <div class="gap-5 mt-6 sub-items-container">
        @if(visaEntryTypeDetails?.length){
        @for(visa of visaEntryTypeDetails; track $index){
        @if ((router.url === '/' && visa.landing) || (router.url !== '/')) {
        <div class="sub-item h-100">
          <img [src]="visa.imagePath">
          <div class="p-3 pt-0">
            <p class="heading-3 linear-gradient-text ibm-bold my-3">{{visa.title}}</p>
            @if(visa.variants?.length && visa.variants[0]?.items?.length){
            <div>
              @for(instruction of visa.variants[0]?.items; track $index){
              <p class="text-3 text-blue-2 ibm-regular line-7"><span class="ibm-bold">{{instruction.title}}:
                </span><span>{{instruction.value}}</span></p>
              }
            </div>
            }
          </div>
        </div>
        }
        }
        }
      </div>
    </div>
  </div>
</div>